import { Currency } from '@kodiak-finance/sdk-core'
import { chainIdToNativeCurrencyName, SupportedChainId } from 'config/chains'
import { ZERO_ADDRESS } from 'constants/misc'

export const currencyId = (currency: Currency, chainId?: SupportedChainId): string => {
  if (currency.isNative) {
    if (chainId) {
      const nativeSymbol = chainIdToNativeCurrencyName[chainId]
      return nativeSymbol
    }

    return 'ETH'
  }

  if (currency.isToken) return currency.address
  throw new Error('invalid currency')
}

export function isNativeCurrencyId(currencyId: string | null | undefined, chainId: SupportedChainId): boolean {
  if (!currencyId) return false

  const upperCurrencyId = currencyId.toUpperCase()

  return (
    upperCurrencyId === chainIdToNativeCurrencyName[chainId] || currencyId === ZERO_ADDRESS || upperCurrencyId === 'ETH'
  )
}
